<template>
    <div class="container-fluid" style="overflow-y: hidden">
      <div class="row">
        <div class="col-12">
          <b-table
            class="textMiddle"
            small
            hover
            bordered
            show-empty
            responsive
            head-variant="light"
            :items="report.data"
            :fields="headers"
            v-bind:emptyText="$store.state.localization.data.common.table.noData"
            :foot-clone="true"
            v-bind:sticky-header="clientHeight"
          >
            <template v-slot:empty="scope">
              <div class="row justify-content-md-center">
                <h5>{{ scope.emptyText }}</h5>
              </div>
            </template>
            <template v-slot:foot()="data">
              <span class="text-success">{{ report.summary[data.column] }}</span>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import {
    utilsService,
    fuelFlowMeterService
  } from "../../../services";
  
  export default {
    name: "FuelFlowMetersTable",
    data() {
      return {
        fuelFlowMeters: null,
        fuelFlowMetersInfo: null,
        timeout: 60 * 1000,
      };
    },
    computed: {
      headers() {
        const headers = [];
  
        for (let key in this.$store.state.localization.data.mainPage.fuelFlowMeters.tableColumns) {
            headers.push({
                key: key,
                label:
                this.$store.state.localization.data.mainPage.fuelFlowMeters.tableColumns[key],
                sortable: true,
                thClass: "textMiddle",
            });
        }
  
        return headers;
      },
      clientHeight() {
        const FUEL_TANKS_POSITION_Y = 140;
  
        return `${
          document.documentElement.clientHeight - FUEL_TANKS_POSITION_Y
        }px`;
      },
      report() {
        const data = [];
  
        const summary = {
          fuelVolumeTotalCounter: 0,
          fuelWeightTotalCounter: 0
        };
  
        if (this.fuelFlowMeters == null || this.fuelFlowMetersInfo == null) {
          return {
            data: data,
            summary: summary,
          };
        }
  
        for (let i = 0; i < this.fuelFlowMeters.length; i++) {
          const row = {
            fuelFlowMeterName: this.fuelFlowMeters[i].name,
            status: "",
            fuelVolumeTotalCounter: 0,
            fuelWeightTotalCounter: 0,
            fuelTemperature: 0,
            fuelDensity: 0,
            fuelFlowRate: 0
          };
  
          const fuelFlowMeterInfo = this.fuelFlowMetersInfo.find(x => x.vehicleId == this.fuelFlowMeters[i].vehicleId && x.input == this.fuelFlowMeters[i].input);

          if (fuelFlowMeterInfo) {
            row.fuelFlowMeterName = this.fuelFlowMeters[i].name,
            row.status = "",
            row.fuelVolumeTotalCounter = fuelFlowMeterInfo.fuelVolumeTotalCounter;
            row.fuelWeightTotalCounter = fuelFlowMeterInfo.fuelWeightTotalCounter;
            row.fuelTemperature = fuelFlowMeterInfo.fuelTemperature;
            row.fuelDensity = fuelFlowMeterInfo.fuelDensity;
            row.fuelFlowRate = fuelFlowMeterInfo.fuelFlowRate;
          }

          data.push({
            fuelFlowMeterName: row.fuelFlowMeterName,
            status: this.$store.state.localization.data.mainPage.fuelFlowMeters.statusOptions.find(x => parseInt(x.key) == fuelFlowMeterInfo.status).value,
            fuelVolumeTotalCounter: utilsService.formatNumber(row.fuelVolumeTotalCounter, 2),
            fuelWeightTotalCounter: utilsService.formatNumber(row.fuelWeightTotalCounter, 2),
            fuelTemperature: utilsService.formatNumber(row.fuelTemperature, 2),
            fuelDensity: utilsService.formatNumber(row.fuelDensity, 3),
            fuelFlowRate: utilsService.formatNumber(row.fuelFlowRate, 2)
          });
  
          summary.fuelVolumeTotalCounter += row.fuelVolumeTotalCounter;
          summary.fuelWeightTotalCounter += row.fuelWeightTotalCounter;
        }
  
        summary.fuelVolumeTotalCounter = utilsService.formatNumber(summary.fuelVolumeTotalCounter, 1);
        summary.fuelWeightTotalCounter = utilsService.formatNumber(summary.fuelWeightTotalCounter, 1);
      
        console.log(JSON.stringify(data));

        return {
          data: data,
          summary: summary,
        };
      },
    },
    async created() {
        const fuelFlowMetersResponse = await fuelFlowMeterService.getFuelFlowMeters();

        if (!fuelFlowMetersResponse.isSuccess) {
            //TODO: added error handling
            return;
        }

        this.fuelFlowMeters = fuelFlowMetersResponse.data.fuelFlowMeters;

        await this.getFuelFlowMetersInfo();
    },
    methods: {
        async getFuelFlowMetersInfo() {
            const fuelFlowMetersResponse = await fuelFlowMeterService.getFuelFlowMetersInfo();

            if (!fuelFlowMetersResponse.isSuccess) {
                return;
            }

            this.fuelFlowMetersInfo = fuelFlowMetersResponse.data.fuelFlowMetersInfo;

            setTimeout(this.getFuelFlowMetersInfo.bind(this), this.timeout);
        },
    },
  };
  </script>
  
  <style>
  .textMiddle {
    vertical-align: middle !important;
    text-align: center !important;
    min-width: 20px !important;
  }
  </style>
  